import { useMutation, useQueryClient } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { usersQueryKeys } from 'utils/query-keys'
import toast from 'react-hot-toast'

interface UpdateResponseLimitingParams {
  response_limiting_strategy: 'no_limiting' | 'legacy' | 'panopticon'
}

const sendUpdateUserResponseLimiting = async (
  userId: string,
  apiParams: UpdateResponseLimitingParams
) => {
  let response = await fetch(
    `${BASE_API_URL}/admin/api/v2/users/${userId}/response_limiting`,
    {
      method: API_METHODS.PUT,
      headers: apiHeaders(store.getState()),
      body: JSON.stringify(apiParams),
    }
  )
  response = handleErrors(response)
  const json = await response.json()
  return json
}

const useUpdateUserResponseLimiting = (userId: string, userUuid: string) => {
  const queryClient = useQueryClient()
  return useMutation(
    (params: UpdateResponseLimitingParams) => {
      return sendUpdateUserResponseLimiting(userId, params)
    },
    {
      onSuccess: () => {
        toast('Response limiting strategy updated successfully')
      },
      onError: () => {
        toast('Failed to update response limiting strategy. Please try again.')
      },
      onSettled: () => {
        queryClient.invalidateQueries(usersQueryKeys.detail(userUuid))
      },
    }
  )
}

export default useUpdateUserResponseLimiting
